import Axios from "@/plugins/Axios";

export class ColaboradorAvisoService {
  async listarAvisosColaborador() {
    const response = await Axios().get("ponto-colaboradores/avisos");
    return response.data;
  }

  async listarAvisosAdmin() {
    const response = await Axios().get("ponto-colaboradores/admin/avisos");
    return response.data;
  }

  async criarAviso(formData) {
    const response = await Axios().post("ponto-colaboradores/admin/avisos", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async alternarStatus(id, ativo) {
    const response = await Axios().put(`ponto-colaboradores/admin/avisos/${id}/toggle-status`, {
      ativo,
    });
    return response.data;
  }

  async excluirAviso(id) {
    const response = await Axios().delete(`ponto-colaboradores/admin/avisos/${id}`);
    return response.data;
  }
}

export default new ColaboradorAvisoService();
